<template>
  <section class='schedule-flow default-content'>
    <div class='schedule-flow__main'>
      <schedule-flow-login
          v-if='step === 0'
          :account-create-link="accountCreateLink"
      />
      <schedule-flow-viewing
          v-if='step === 1'
          :property='property'
          :subscription='subscription'
          :agendaRoute='agendaRoute'
          :route='route'
          :edit-route='editRoute'
          :excludedDays='excludedDays'
          :excludedDates='excludedDates'/>
      <schedule-flow-confirmation
          v-if='step === 2'
          :subscription='subscription'
      />
      <a v-if='step === 2' href='/' class='theme-btn theme-btn--text hidden lg:inline-flex'>
        {{locales.common && locales.common.go_to_home_page}}
        <i class='icon-go-right'/>
      </a>
    </div>
    <div class='schedule-flow__side mb-10'>
      <div class='schedule-flow__apartment'>
        <div class='schedule-flow__apartment-topic'>
          <div class='schedule-flow__apartment-image-holder'>
            <img class='schedule-flow__apartment-image' :src='property.mainPhoto' alt='photo'>
          </div>
          <div class='schedule-flow__apartment-heading'>
            <div class='schedule-flow__apartment-name'>{{property.listingAddress}}</div>
            <div class='schedule-flow__apartment-address'>{{property.postcode}}, {{property.location}}</div>
          </div>
        </div>
        <div v-if='step <= 1' class='schedule-flow__apartment-info'>
          <div class='schedule-flow__apartment-info-title'>
            {{ locales.properties && locales.properties.price_details }}
          </div>
          <div class='schedule-flow__apartment-info-area'>
            <div class='schedule-flow__apartment-info-row'>
              <span class='schedule-flow__apartment-info-item'>{{ locales.properties && locales.properties.price }}</span>
              <span class='schedule-flow__apartment-info-item'>€ {{ property.ah_price }}</span>
            </div>
            <div class='schedule-flow__apartment-info-row'>
              <span class='schedule-flow__apartment-info-item'>{{ locales.property && locales.property.deposit }}</span>
              <span class='schedule-flow__apartment-info-item'>€ {{ property.depositAmount ? property.depositAmount : 0 }}</span>
            </div>
          </div>
        </div>
        <div v-else class='schedule-flow__apartment-contact'>
          <div class='schedule-flow__apartment-contact-row'>
              <span class='schedule-flow__apartment-contact-title'>
                Contact host
              </span>
            <div class='schedule-flow__apartment-contact-actions'>
              <a :href='`mailto:`+property.landlord.email'><i class='icon-mail'/></a>
              <a :href='`tel:`+property.landlord.phone_number'><i class='icon-phone'/></a>
            </div>
          </div>
          <a href='#' class='theme-btn theme-btn--block theme-btn--destructive' :aria-disabled='cancelling ? "true" : "false"' @click.prevent='cancel'>
            {{ locales.appointments && locales.appointments.cancel_viewing }}
          </a>
        </div>
      </div>
    </div>
    <div v-if='step === 2' class='flex justify-center lg:hidden'>
      <a href='/' class='theme-btn theme-btn--text'>
        {{locales.common && locales.common.go_to_home_page}}
        <i class='icon-go-right'/>
      </a>
    </div>
  </section>
</template>

<script>
  import sweetalert from 'sweetalert';
  import { mapGetters } from 'vuex'
  export default {
    props: {
      isLogged: {
        default: '',
        type: String
      },
      property: {
        default: () => {},
        type: Object,
      },
      subscription: {
        default: () => {},
        type: Object,
      },
      agendaRoute: {
        default: "",
        type: String
      },
      route: {
        default: "",
        type: String
      },
      editRoute: {
        default: "",
        type: String
      },
      redirectUrl: {
        default: "",
        type: String
      },
      cancelRoute: {
        default: "",
        type: String
      },
      accountCreateLink: {
        default: '',
        type: String,
      },
      excludedDays: {
        default: [],
        type: Array
      },
      excludedDates: {
        default: [],
        type: Array
      }
    },
    data() {
      return {
        // True from the click until the candidate declines, the request fails, or the page
        // redirects, so repeated clicks can neither stack dialogs nor send a second DELETE.
        cancelling: false,
      };
    },
    created() {
      if (this.isLogged) {
        this.$store.commit('CHANGE_SCHEDULE_STEP', 1)
      }
      this.$store.commit('APPOINTMENT_ID', null)
    },
    computed: {
      ...mapGetters(['locales']),
      step: function() {
        return this.$store.getters.getScheduleStep;
      },
      appointmentId: function() {
        return this.$store.getters.getAppointmentId;
      },
    },
    methods: {
      // Withdraws the candidate's own pending appointment (api.appointments.cancel) - only after
      // they confirm, like every other viewing cancellation. This is not the sign-out of an
      // accepted/shared viewing (helpers/viewingSignOut.js), whose separate late-cancellation
      // warning is the server's to request; nothing here sends confirm_late.
      cancel() {
        var that = this;
        if (that.appointmentId === null || that.cancelling) {
          return;
        }
        that.cancelling = true;
        var locales = that.locales || {};
        var common = locales.common || {};
        sweetalert(locales.appointments && locales.appointments.are_you_sure_you_want_to_cancel, {
          icon: 'warning',
          dangerMode: true,
          buttons: {
            cancel: { text: common.cancel, value: false, visible: true },
            confirm: { text: common.confirm || common.ok, value: true },
          },
        }).then(function (confirmed) {
          // Cancel button, Escape and a click outside all resolve falsy: no request.
          if (confirmed !== true) {
            that.cancelling = false;
            return;
          }
          that.sendCancellation();
        });
      },
      sendCancellation() {
        var that = this;
        $.ajax({
          url: that.cancelRoute.replace(':aid', that.appointmentId),
          method: "delete",
          cache: false,
          success: function (result, textStatus, xhr) {
            sweetalert(
              window.app.locales.common.success,
              window.app.locales.common.success,
              "success"
            ).then((res) => {
                  // console.log(that.redirectUrl);
                  var redirect = that.redirectUrl;
                  window.location.replace(redirect);
            });
          },
          error: function (result) {
            if (result.status == 303) {
              window.location.replace(result.responseJSON.redirect);
            } else {
              that.cancelling = false;
              sweetalert(
                window.app.locales.common.error,
                window.app.locales.common.error,
                "error"
              );
            }
          },
        });
      },
    },
  };
</script>